import React, {useState, useEffect} from 'react';
import {Input} from 'reactstrap';
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';
import {IconButton} from "@mui/material";
import {logoutUserFromEmail} from "Store/Actions";
import {LanguageSelect} from "Components/LanguageSelect/LanguageSelect";

function Header(props) {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const dispatch = useDispatch();
    const isLogin = useSelector((state) => state.authUser.isLogin);
    const userName = useSelector((state) => state.authUser.userName);
    const accessToken = useSelector((state) => state.authUser.accessToken);
    const userCompletedCount = useSelector((state) => state.authUser.completedCount);
    const userCompletedPoint = useSelector((state) => state.authUser.completedPoint);
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        const searchParam = searchParams.get('search');
        if (searchParam) {
            setSearchText(searchParam);
        }
    }, []);

    const getAvatarChars = () => {
        if (!userName) return '';
        const names = userName.split(' ');
        if (names.length >= 2) {
            return names[0][0] + names[1][0];
        } else {
            return names[0][0] + names[0][1];
        }
    }

    const changeSearchText = (text) => {
        setSearchText(text);
        if (text.length > 0) {
            navigate('/main?search=' + text, {replace: true});
        } else {
            navigate('/main', {replace: true});
        }
        if (location.pathname.indexOf('/main') === -1) {
            navigate('/main?search=' + text, {replace: true});
        }
        if (location.pathname.indexOf('/main') === -1) {
            navigate('/main?search=' + text);
        }
    }

    const onSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            onSearch();
        }
    }

    const onSearch = () => {
        let path;
        if (searchText.length > 0) {
            path = '/main?search=' + searchText;
        } else {
            path = '/main';
        }
        if (location.pathname.indexOf('/main')) {
            navigate(path, {replace: true});
        } else {
            navigate(path);
        }
    }

    const onLogout = () => {
        dispatch(logoutUserFromEmail());
        navigate('/');
    }

    return (
        <div className={'main-header'}>
            <div className={'header-logo'}>
                <a href={'https://detectedx.com'}>
                    <h1>
                    <img src={require('Assets/img/main/header_logo.png')} alt={'DetectedX Logo'}/>
                        </h1>
                </a>
            </div>
            <div className={'header-searchbar'}>
                {
                    isLogin ?
                        <div
                            className={'home-icon'}
                            onClick={() => {
                                const currentPath = window.location.pathname;
                                if (currentPath.includes('app')) {
                                    const newPath = currentPath.replace('app', 'lecturer');
                                    const basePath = `${newPath.split('.com')[0]  }.com`;
                                    const finalPath = `${basePath  }/signin?token=${  accessToken}`;
                                    window.open(finalPath, '_blank');
                                } else {
                                    window.open(`https://lecturer.detectedx.com/signin?token=${accessToken}`, '_blank');
                                }
                            }}
                        >
                            <img src={require('Assets/img/main/AddTo.svg').default} alt={'Creator View'}/>
                            <div className={'home-icon-placeholder'}>
                                Creator View
                            </div>
                        </div> : <div style={{width: 80}} />
                }
                <div className={'home-icon'} onClick={() => navigate('/main')}>
                    <img src={require('Assets/img/main/icon_home.svg').default} alt={'Home'}/>
                    <div className={'home-icon-placeholder'}>
                        Home
                    </div>
                </div>
                <div className={'search-input'}>
                    <label htmlFor="search-field" className="visually-hidden">Search</label>
                    <Input
                        id="search-field"
                        value={searchText}
                        onChange={(e) => changeSearchText(e.target.value)}
                        onKeyPress={onSearchKeyPress}
                    />
                    <IconButton className={'search-input-btn'} onClick={onSearch}>
                        <img src={require('Assets/img/main/icon_search.svg').default} alt={'Search icon'}/>
                    </IconButton>
                </div>
            </div>
            <div className={'header-user-info d-flex flex-row align-items-center'}>
                <div className={'header-user-avatar'} onClick={() => navigate('/main/profile')}>
                    {/*<img src={require('Assets/img/main/temp_user.png')} alt={''}/>*/}
                    {
                        isLogin ?
                            <span>{getAvatarChars()}</span> :
                            <i className={'zmdi zmdi-account'}/>
                    }
                </div>
                <div className={'info-block'}>
                    {
                        isLogin ?
                            <div className={'d-flex flex-row justify-content-between align-items-center'}>
                                <span className={'fs-23 fw-semi-bold'}>{userName}</span>
                                <span className={'fs-16 fw-semi-bold text-primary1 cursor-pointer'} onClick={onLogout}>LOGOUT</span>
                            </div> :
                            <span className={'fs-23 fw-semi-bold cursor-pointer'} onClick={() => navigate('/main/profile')}>Login</span>
                    }
                    <div className={'fs-14 cursor-pointer'} onClick={() => navigate('/main/profile?tab=completed')}>
                        <span>COMPLETED<span className={'hide-mobile'}> MODULES</span>:</span>
                        <span className={'info-num'}>{isLogin ? (!isNaN(userCompletedCount) ? userCompletedCount : 0) : ''}</span>
                        <span><span className={'hide-mobile'}>THIS YEARS </span>CME POINTS:</span>
                        <span className={'info-num'}>{isLogin ? (!isNaN(userCompletedPoint) ? Number(userCompletedPoint).toFixed(2) : 0) : ''}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;